<template>
  <main class="main-content">
    <component :is="NavItem"></component>
    <div class="overview-section">
      <div class="section-header">
        <div class="icon-container ##114CAC">
          <img src="/img/icons/dashboard2.png" alt="D">
        </div>
        <h2>Dashboard Overview</h2>
      </div>

      <div class="metrics-grid">
        <div class="metric-card">
          <div class="metric-icon">
            <img src="/img/icons/files.png" alt="D">
          </div>
          <div class="metric-content">
            <div class="metric-header">
              <span>Quotes - Today</span>
            </div>
            <div class="metric-value">100</div>
            <div class="metric-footer">
                  <span class="metric-timestamp">
                    <i class="fas fa-circle"></i>
                    Just Updated
                  </span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <div class="metric-icon">
            <img src="/img/icons/files.png" alt="D">
          </div>
          <div class="metric-content">
            <div class="metric-header">
              <span>Quotes - Weekly</span>
            </div>
            <div class="metric-value">100</div>
            <div class="metric-footer">
                  <span class="metric-timestamp">
                    <i class="fas fa-circle"></i>
                    Just Updated
                  </span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <div class="metric-icon">
            <img src="/img/icons/files.png" alt="D">
          </div>
          <div class="metric-content">
            <div class="metric-header">
              <span>Potential Earnings</span>
            </div>
            <div class="metric-value">Kes. 500,000</div>
            <div class="metric-footer">
                  <span class="metric-timestamp">
                    <img src="/img/icons/files.png" alt="D">
                    Just Updated
                  </span>
            </div>
          </div>
        </div>

        <div class="metric-card">
          <div class="metric-icon">
            <img src="/img/icons/files.png" alt="D">
          </div>
          <div class="metric-content">
            <div class="metric-header">
              <span>No. of Quotes - This Month</span>
            </div>
            <div class="metric-value">100</div>
            <div class="metric-footer">
                  <span class="metric-timestamp">
                    <img src="/img/icons/files.png" alt="D">
                    Just Updated
                  </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="saved-quotes-section">
      <div class="section-header">
        <div class="icon-container">
          <img src="/img/icons/doc3.png" alt="D">
        </div>
        <h2>Saved Quotes</h2>
        <div class="actions">
          <i class="fas fa-search"></i>
          <i class="fas fa-ellipsis-v"></i>
        </div>
      </div>

      <div class="quotes-table">
        <table>
          <thead>
          <tr>
            <th>Customer</th>
            <th>Phone</th>
            <th>ID No.</th>
            <th>Cover Type</th>
            <th>Quote Type</th>
            <th>Last Updated</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(quote, index) in savedQuotes" :key="index">
            <td>{{ quote.customer }}</td>
            <td>{{ quote.phone }}</td>
            <td>{{ quote.idNo }}</td>
            <td>{{ quote.coverType }}</td>
            <td>{{ quote.quoteType }}</td>
            <td>{{ quote.lastUpdated }}</td>
            <td>
              <i class="fas fa-eye action-icon"></i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <span>Rows per page:</span>
        <select v-model="rowsPerPage">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
        <span>1-10 of 100</span>
        <div class="pagination-controls">
          <i class="fas fa-chevron-left"></i>
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import NavItem from '@/admin/components/nav/NavItem.vue';

export default {
  computed: {
    NavItem() {
      return NavItem;
    },
  },
  components: {
    NavItem,
  },
  name: 'LandingScreen',
  data() {
    const PHONE_PLACEHOLDER = '+254 70164 34...';
    const ID_NUMBER = '34227880';
    const LAST_UPDATED = '22/07/2020';
    const ELIMU_PLAN = 'Elimu Plan';
    const IMARIKA_PLAN = 'Imarika Plan';
    const PREMIUM = 'Premium';
    const SUM_ASSURE = 'Sum Assure';
    return {
      rowsPerPage: 10,
      savedQuotes: [
        {
          customer: 'Douglas K. Marete',
          phone: PHONE_PLACEHOLDER,
          idNo: ID_NUMBER,
          coverType: ELIMU_PLAN,
          quoteType: SUM_ASSURE,
          lastUpdated: LAST_UPDATED,
        },
        {
          customer: 'Joel M. Kararu',
          phone: PHONE_PLACEHOLDER,
          idNo: ID_NUMBER,
          coverType: IMARIKA_PLAN,
          quoteType: PREMIUM,
          lastUpdated: LAST_UPDATED,
        },
        {
          customer: 'Eunice O Madiba',
          phone: PHONE_PLACEHOLDER,
          idNo: ID_NUMBER,
          coverType: ELIMU_PLAN,
          quoteType: PREMIUM,
          lastUpdated: LAST_UPDATED,
        },
        {
          customer: 'Lindsey D Athey',
          phone: PHONE_PLACEHOLDER,
          idNo: ID_NUMBER,
          coverType: IMARIKA_PLAN,
          quoteType: PREMIUM,
          lastUpdated: LAST_UPDATED,
        },
        {
          customer: 'George P Miller',
          phone: PHONE_PLACEHOLDER,
          idNo: ID_NUMBER,
          coverType: ELIMU_PLAN,
          quoteType: SUM_ASSURE,
          lastUpdated: LAST_UPDATED,
        },
        {
          customer: 'Eunice O Madiba',
          phone: PHONE_PLACEHOLDER,
          idNo: ID_NUMBER,
          coverType: IMARIKA_PLAN,
          quoteType: SUM_ASSURE,
          lastUpdated: LAST_UPDATED,
        },
        {
          customer: 'Lindsey D Athey',
          phone: PHONE_PLACEHOLDER,
          idNo: ID_NUMBER,
          coverType: ELIMU_PLAN,
          quoteType: SUM_ASSURE,
          lastUpdated: LAST_UPDATED,
        },
      ],
    };
  },
};
</script>

<style scoped>

.sidebar-item i {
  width: 20px;
  color: #004aad !important;
}

.sidebar-item.active i {
  color: #fff;
}
.user-profile span {
  font-size: 0.9rem;
  color: #333;
}
.sidebar-item img {
  width: 20px;
  height: auto;
  vertical-align: middle;
  filter: grayscale(100%);
  opacity: 0.8;
}

.sidebar-item.active img {
  filter: grayscale(0%);
  opacity: 1;
}

.main-content {
  flex: 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background-color: #f0f2f5;
  left: 16%;
  margin-top: 4%;
  width: 100%;

}

.overview-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
}

.icon-container {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  background-color: #114CAC;
}

.blue {
  background-color: #007bff;
}
.light-blue {
  background-color: #e0f7fa;
  color: #007bff;
}
.light-blue i {
  color: #007bff;
}

.white-icon {
  color: white;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

.metric-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 1.25rem;
  display: flex;
  align-items: flex-start;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.03);
}

.metric-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: white;
  font-size: 1.1rem;
  background-color: #114CAC;
}

.metric-content {
  flex: 1;
}

.metric-header {
  margin-bottom: 0.6rem;
  color: #777;
  font-size: 0.85rem;
}

.metric-value {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}

.metric-footer {
  color: #999;
  font-size: 0.8rem;
}

.metric-timestamp i {
  font-size: 6px;
  vertical-align: middle;
  margin-right: 0.2rem;
}

.saved-quotes-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.dashboard-section .section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.section-header h2 {
  flex: 1;
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}

.actions {
  display: flex;
  gap: 1.25rem;
  color: #777;
}
.actions i {
  cursor: pointer;
}

.quotes-table {
  margin-top: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 0.85rem 1rem;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.85rem;
  color: #555;
}

th {
  font-weight: 500;
  color: #777;
  background-color: #f8f8f8;
}
th:first-child, td:first-child {
  padding-left: 1.5rem;
}
th:last-child, td:last-child {
  padding-right: 1.5rem;
  text-align: center;
}

.action-icon {
  color: #007bff;
  cursor: pointer;
  font-size: 1rem;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1.25rem;
  font-size: 0.85rem;
  color: #777;
}

.pagination > * {
  margin: 0 0.75rem;
}

.pagination span, .pagination select {
  margin-right: 0.75rem;
}

.pagination select {
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.85rem;
  color: #555;
}

.pagination-controls {
  display: flex;
  gap: 0.5rem;
}

.pagination-controls i {
  cursor: pointer;
  padding: 0.3rem 0.6rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
  background-color: #fff;
  color: #555;
  transition: background-color 0.2s, color 0.2s;
}
.pagination-controls i:hover {
  background-color: #f0f0f0;
}
</style>
